import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import TokenModel from './tokens';
import HotPairsModel from './hotPairs';
import {CButton, CFormInput, CInputGroup} from '@coreui/bootstrap-react';
import DashboardsService from '../store/dashboards/service';
import {toast} from 'react-hot-toast';
import {useState} from 'react';
import {useDispatch} from 'react-redux';
import Communication from '../communication';
import config from '../config';
import {Dropdown, DropdownButton} from "react-bootstrap";

const BaseNavbar = () => {
    const dispatch = useDispatch()
    const [contract, setContract] = useState()
    const [network, setNetwork] = useState({'name': 'اتریوم', 'key': 'eth'})
    const [loading, setLoading] = useState(false)

    const handelAnalysis = () => {
        setLoading(true)
        Communication.postMethod(
            config.endPoints.add_token,
            {contract: contract, network_id: network.key}
        ).then(data => {
            if (data?.message) {
                toast.error(data.message);
            } else {
                toast.success('توکن جدید شما با موفقیت به لیست توکن ها اضافه گردید، هم اکنون می توانید از بخش توکن ها به داشبور مورد نظر خود اضافه نمایید.')
            }
        }).catch(() => {
        }).finally(() => {
            setLoading(false)
        })
    }

    return (
        <Navbar expand="lg" className="bg-body-tertiary">
            <Container>
                <Navbar.Brand>مانیتورینگ</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link>داشبورد</Nav.Link>
                        <TokenModel/>

                        <Nav.Link>داشبورد</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
                <Navbar.Collapse className="justify-content-end">
                    <Navbar.Text>
                        <CInputGroup className="mb-3">
                            <CFormInput placeholder="آدرس کانترکت  ... " disabled={loading}
                                        aria-label="آدرس کانترکت مورد نظر خود را وارد کنید ... "
                                        onChange={(e) => (setContract(e.target.value))}
                                        aria-describedby="button-addon2"
                            />
                            <DropdownButton
                                variant="outline-secondary"
                                title={network.name}
                                id="input-group-dropdown-1"
                            >
                                <Dropdown.Item onClick={()=>(setNetwork({'name': 'اتریوم', 'key': 'eth'}))}>اتریوم</Dropdown.Item>
                                <Dropdown.Item onClick={()=>(setNetwork({'name': 'بیس', 'key': 'base'}))}>بیس</Dropdown.Item>
                            </DropdownButton>
                            <CButton type="button" disabled={loading} color="secondary" variant="outline"
                                     id="button-addon2" onClick={() => (handelAnalysis())}>

                                افزودن
                            </CButton>


                        </CInputGroup>
                    </Navbar.Text>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default BaseNavbar;